import { ObjUtils } from "./ObjUtils";

export class Guid {

	private static _guidRegEx = new RegExp("^[A-Fa-f0-9]{32}$|" +
		"^({|\\()?[A-Fa-f0-9]{8}-([A-Fa-f0-9]{4}-){3}[A-Fa-f0-9]{12}(}|\\))?$|" +
		"^({)?[0xA-Fa-f0-9]{3,10}(, {0,1}[0xA-Fa-f0-9]{3,6}){2}, {0,1}({)([0xA-Fa-f0-9]{3,4}, {0,1}){7}[0xA-Fa-f0-9]{3,4}(}})$");

	private static _upcaseRegEx = new RegExp("[A-F]");

	public static FromString(guidStr: string): Guid {
		var result: Guid = null;

		if (this._guidRegEx.test(guidStr))
			result = new Guid(guidStr);

		return result;
	}

	constructor(public GuidStr: string) {

		if (!!GuidStr && Guid._upcaseRegEx.test(GuidStr)) {
			GuidStr = GuidStr.toLowerCase();
		}

		if (!Guid._guidRegEx.test(GuidStr)) {
			throw {
				Name: 'GuidException',
				Message: 'Unable to parse GUID'
			};
		}
    }

    public toString(): string {
        return this.GuidStr;
    }

	public ToString(): string {
		return this.toString();
	}

    // Static member
    public static Create(): Guid {
        var result: string;
        var i: string;
        var j: number;

        result = "";
        for (j = 0; j < 32; j++) {
            if (j == 8 || j == 12 || j == 16 || j == 20)
				result = result + '-';
			i = Math.floor(Math.random() * 16).toString(16).toLowerCase();
            result = result + i;
        }
        return new Guid(result);
    }

	private static _empty:Guid = Guid.FromString("00000000-0000-0000-0000-000000000000");
	public static get Empty(): Guid {
		return Guid._empty;
	}

	public Equals(obj: any) {
		if (obj == null)
			return false;

		if (this === obj)
			return true;

		if (!(obj instanceof Guid))
			return false;

		var other = <Guid> obj;

		return this.GuidStr.toLowerCase() == other.GuidStr.toLowerCase();
	}

	public GetHashCode(): number {
		return ObjUtils.GetHashCode(this.GuidStr.toLowerCase());
	}

}